export const model = {
  date: '',
  warehouse_id: '',
  // receiver_id: '' ,
  sender_id: ''
};